import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/header.css';

const navLinks = [
  { to: '/',         label: 'HOME' },
  { to: '/about',    label: 'ABOUT-US' },
  { to: '/business', label: 'BUSSINESS' },
  { to: '/client', label: 'CLIENT' },
  { to: '/services', label: 'SERVICES' },
  { to: '/contact',  label: 'CONTACT-US' },
  { to: '/career',   label: 'CAREER' },
];

export default function Header() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu when a nav link is clicked
  const handleNavClick = () => setMenuOpen(false);

  return (
    <header className="main-header">
      <div className="top-header" />
      <div className="botom-header">
        <div className="container">

          {/* LOGO */}
          <Link to="/" className="logo">
            <img
              src="/images/LevanteLogo2.jpg"
              alt="Matrix Processing House"
              className="logo-img"
            />
            <span className="logo-text">Matrix Processing House</span>
          </Link>

          {/* HAMBURGER BUTTON — only visible on mobile via CSS */}
          <button
            className={`nav-toggle${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>

          {/* NAV */}
          <nav className={`nav-main${menuOpen ? ' open' : ''}`}>
            <ul>
              {navLinks.map((l, i) => (
                <li key={i} className={pathname === l.to ? 'active' : ''}>
                  <Link to={l.to} onClick={handleNavClick}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

        </div>
      </div>
    </header>
  );
}